import _ from 'lodash'
import {
  GridApi,
  CellRange,
  CellSelectionChangedEvent,
  RowPosition,
} from 'ag-grid-community'

export const onCellSelectionChanged = ({
  api,
  started,
  finished,
}: CellSelectionChangedEvent) => {
  const focusedCell = api.getFocusedCell()
  if (
    !focusedCell ||
    !focusedCell.column ||
    focusedCell.column.getColDef().field === 'drag'
  ) {
    return
  }
  if (started && !finished) {
    api.deselectAll()
  }
  if (finished) {
    selectRows(api)
  }
}

const selectRows = (api: GridApi) => {
  const ranges = api.getCellRanges() || []
  const rangeIndexes = ranges.map(range => rangeToNormalRowIndexes(api, range))
  const rowIndexes: number[] = rangeIndexes.flat().filter(v => v !== undefined)
  const selectedNodes = api.getSelectedNodes()
  selectedNodes.forEach(
    node =>
      node.rowIndex !== null &&
      !rowIndexes.includes(node.rowIndex) &&
      node.setSelected(false)
  )
  rowIndexes.forEach(i => {
    const node = api.getDisplayedRowAtIndex(i)
    node && node.setSelected(true)
  })
}

const rangeToNormalRowIndexes = (api: GridApi, range: CellRange): number[] => {
  const { startRow, endRow } = range
  if (!startRow || !endRow) {
    return []
  }
  if (
    startRow.rowPinned &&
    endRow.rowPinned &&
    startRow.rowPinned === endRow.rowPinned
  ) {
    return []
  }
  const toNormalRowIndex = (row: RowPosition): number | null => {
    if (!row.rowPinned) {
      return row.rowIndex
    }
    if (row.rowPinned === 'top') {
      return 0
    }
    const lastRowIndex = api.getDisplayedRowCount() - 1
    return lastRowIndex >= 0 ? lastRowIndex : null
  }
  const start = toNormalRowIndex(startRow)
  const end = toNormalRowIndex(endRow)
  if (start === null || end === null) {
    return []
  }
  return start <= end ? _.range(start, end + 1) : _.range(end, start + 1)
}
